import { render, staticRenderFns } from "./TournamentNotStarted.vue?vue&type=template&id=78a49b0a"
import script from "./TournamentNotStarted.vue?vue&type=script&lang=js"
export * from "./TournamentNotStarted.vue?vue&type=script&lang=js"
import style0 from "./TournamentNotStarted.vue?vue&type=style&index=0&id=78a49b0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports